import { useStore } from "@nanostores/react"

import { $elementHeightStore } from "./element-height-store"

/**
 * Hook to access element heights from the nanostore.
 *
 * @param key - The key of the element height to retrieve (same as variableName in useElementHeight)
 * @returns The current height of the element in pixels, or undefined if not set
 *
 * @example
 * ```tsx
 * const headerHeight = useElementHeightStore("header-height")
 * // headerHeight will be a number (in pixels) or undefined
 * ```
 */
export function useElementHeightStore(key: string): number {
  const store = useStore($elementHeightStore)
  return store[key] ?? 0
}
